module.exports = __webpack_public_path__ + "img/regular_in_installation.95bcfe0c.svg";